<template>
  <div class="h-dialogContainer">
    <div class="row">
      <div class="col-sm-6">
        <div class="h-borderBox height-260">
          <div class="h-borderTree-pm-content">
            <NeTreeForNoRealTaskModify ref="NeTreeForNoRealTaskModify" @measureTreeShowTypeChange="measureTreeShowTypeChange"></NeTreeForNoRealTaskModify>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="h-borderBox height-260">
          <div class="h-borderTree-pm-content">
            <MeasureTreeForNoRealTaskModify ref="MeasureTreeForNoRealTaskModify" :measureTreeShowType="measureTreeShowType"></MeasureTreeForNoRealTaskModify>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="h-btnBox">
          <ejs-button id="btnFive1" iconCss="icon hero-icon hero-icon-double-down" cssClass="h-btn-put" :isPrimary="true" v-on:click.native="addCounters">{{$t('Pm.addToFollow')}}</ejs-button>
        </div>
      </div>
    </div>
    <div class="row">
      <MeasureListForNoRealTaskModify id="MeasureListForNoRealTaskModify" ref="MeasureListForNoRealTaskModify"></MeasureListForNoRealTaskModify>
    </div>
  </div>
</template>

<script>
  import NeTreeForNoRealTaskModify from '../tree/NeTreeForNoRealTaskModify';
  import MeasureTreeForNoRealTaskModify from '../tree/MeasureTreeForNoRealTaskModify';
  import MeasureListForNoRealTaskModify from "../MeasureListForNoRealTaskModify";
  import {EventBus} from "../../../../../../plugins/eventBus";

  export default {
    name: 'ModifyNoRealTaskDialog2',
    props: [
      'paramsOfNoRealTaskModifyDialog1'
    ],
    components: {
      NeTreeForNoRealTaskModify,
      MeasureTreeForNoRealTaskModify,
      MeasureListForNoRealTaskModify
    },
    data() {
      return {
        measureTreeShowType: 2,
        treeGridList: [],
        paramsOfNoRealTaskModifyDialog2: {
          neId: '',
          moIdNum: 0,
          moIdList: [],
          counterIdNum: 0,
          counterIdList: []
        }
      }
    },
    methods: {
      measureTreeShowTypeChange(msg) {
        this.measureTreeShowType = msg;
      },
      addCounters(){
        this.paramsOfNoRealTaskModifyDialog2.counterIdList = [];
        this.treeGridList = [];
        const NeTreeForModify = this.$refs.NeTreeForNoRealTaskModify.$refs.neTreeForNoRealTaskModify;
        const selectedNodesOfNeTree = NeTreeForModify.ej2Instances.selectedNodes;
        const neSelect = NeTreeForModify.getTreeData(selectedNodesOfNeTree[0])[0];

        // 过滤树中的非网元节点
        if (!neSelect || !neSelect.attributes || !neSelect.attributes.neId) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectResource') });
          return;
        }

        this.paramsOfNoRealTaskModifyDialog2.neId = neSelect.attributes.neId;

        // 获取指标树中选中的指标信息
        let counterObj = null;
        let measureObj = null;
        let measureObjCodeList = [];
        let MeasureObjTreeForModify = this.$refs.MeasureTreeForNoRealTaskModify.$refs.MeasureTreeForNoRealModify;
        const checkNodesOfMeasureObjTree = MeasureObjTreeForModify.getAllCheckedNodes();

        // 过滤树中的非网测量对象节点
        if (checkNodesOfMeasureObjTree.length == 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
          return;
        }
        for (let i = 0; i < checkNodesOfMeasureObjTree.length; i++) {
          // 获取选中节点信息
          const nodeChecked = MeasureObjTreeForModify.getTreeData(checkNodesOfMeasureObjTree[i])[0];

          // 筛除掉父级非测量对象节点
          if (nodeChecked.children.length > 0 || nodeChecked.attributes.measureObjTypeCode != null) {
            continue;
          }

          // 将选中的测量对象节点信息存入measureObj中
          counterObj = {
            measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
            counterName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.counterNameCH : nodeChecked.attributes.counterNameOT,
            id: nodeChecked.attributes.counterCode,
            parentItem: nodeChecked.attributes.measureObjCode,
            isParent:false
          }
          this.paramsOfNoRealTaskModifyDialog2.counterIdList.push(nodeChecked.attributes.counterCode);

          measureObj = {
            measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
            counterName: '',
            id: nodeChecked.attributes.measureObjCode,
            parentItem: null,
            isParent:true
          }

          if(measureObjCodeList.indexOf(nodeChecked.attributes.measureObjCode) == -1){
            this.treeGridList.push({
              measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
              counterName: '',
              id: nodeChecked.attributes.measureObjCode,
              parentItem: null,
              isParent:true
            });
            measureObjCodeList.push(nodeChecked.attributes.measureObjCode);
            this.paramsOfNoRealTaskModifyDialog2.moIdList.push(nodeChecked.attributes.measureObjCode);
          }

          // 将measureObj存入treeGridList中作为treeGrid的子节点
          this.treeGridList.push(counterObj);
          counterObj = null;
        }
        // 更新加载表格的数据源
        this.paramsOfNoRealTaskModifyDialog2.moIdNum = this.paramsOfNoRealTaskModifyDialog2.moIdList.length;
        this.paramsOfNoRealTaskModifyDialog2.counterIdNum = this.paramsOfNoRealTaskModifyDialog2.counterIdList.length;
        this.$refs.MeasureListForNoRealTaskModify.dataOfNoRealTaskModifyList = this.treeGridList;
      }
    }
  };
</script>

<style>
</style>
